<div [class]="visible ? 'flex flex-col h-full' : 'hidden'">
  <div class="h-full flex flex-col">
    <p-splitter class="w-full grow" layout="vertical" styleClass="h-full" [panelSizes]="[60, 40]">
      <ng-template pTemplate>
        <div class="h-full w-full flex flex-col ">
          <div class="flex">
            <div class="w-1/3 pt-4 pb-3">
              <p-button [disabled]="parent.isReadOnly()" (onClick)="onAddPbc()"
                label="Add Program Billing Config" id="addBillingConfigBtn" icon="pi pi-plus"
                size="small"></p-button>
            </div>
          </div>
          <div class="grow w-full">
            <prox-ag-grid gridId="programBillingConfigsGrid" [gridOptions]="pbcGridOptions"
              [rowData]="programBillingConfigs"></prox-ag-grid>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate>
        <div class="h-full w-full flex flex-col ">
          <div class="flex gap-4">
            <div class="ml-4 pt-5 pb-3">
              <label class="font-bold">All Account Manifests</label>
            </div>
            <div class="pt-3 pb-3">
              <p-button [disabled]="parent.isReadOnly()" (onClick)="onAddManifest()"
                label="Add Manifest" icon="pi pi-plus" size="small"></p-button>
            </div>
          </div>
          <div class="grow">
            <prox-ag-grid gridId="manifestsGrid" [gridOptions]="manifestGridOptions" [rowData]="manifests"
              [hasColSizeButtons]="false"></prox-ag-grid>
          </div>
        </div>
      </ng-template>
    </p-splitter>
  </div>
</div>